import { z } from 'zod';
import http from '@/lib/http';
import {
  CompanyAccessKeyDto,
  CompanyAccessKeyResponse,
  CompanyAccessKeyResponseSchema,
  OrganizationUserDto,
  OrganizationUserDtoSchema,
  UpdateOrganizationUserDto,
  SuccessResponse,
  SuccessResponseSchema,
} from '@cargovibe/shared-types';

export const getOrganizationUsers = async (): Promise<OrganizationUserDto[]> => {
  return http.get<OrganizationUserDto[]>(
    '/getOrganizationUsers',
    z.array(OrganizationUserDtoSchema)
  );
};

export const updateOrganizationUser = async (
  userId: string,
  data: UpdateOrganizationUserDto
): Promise<OrganizationUserDto> => {
  return http.patch<OrganizationUserDto>(
    `/updateOrganizationUser?userId=${encodeURIComponent(userId)}`,
    OrganizationUserDtoSchema,
    data
  );
};

export const deleteOrganizationUser = async (userId: string): Promise<SuccessResponse> => {
  return http.delete<SuccessResponse>(
    `/deleteOrganizationUser?userId=${encodeURIComponent(userId)}`,
    SuccessResponseSchema
  );
};

export const getCompanyAccessKey = async (): Promise<CompanyAccessKeyDto | null> => {
  const response: CompanyAccessKeyResponse = await http.get<CompanyAccessKeyResponse>(
    '/getCompanyAccessKey',
    CompanyAccessKeyResponseSchema
  );
  return response.data;
};
